import { render, staticRenderFns } from "./TextAreaReadOnly.vue?vue&type=template&id=d5612c5e&"
import script from "./TextAreaReadOnly.vue?vue&type=script&lang=js&"
export * from "./TextAreaReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5612c5e')) {
      api.createRecord('d5612c5e', component.options)
    } else {
      api.reload('d5612c5e', component.options)
    }
    module.hot.accept("./TextAreaReadOnly.vue?vue&type=template&id=d5612c5e&", function () {
      api.rerender('d5612c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/textarea/TextAreaReadOnly.vue"
export default component.exports